import { RouterState } from 'reactApp/modules/router/router.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { createSelector } from 'reselect';

const getRouterState = (state): RouterState => state.router;

export const getCurrentRouteId = createSelector(getRouterState, (state): string => state.id);

/** TODO: getCurrentStorage - поменьше это юзать! Лучше прокидывать сторадж как свойство! */
export const getCurrentStorage = createSelector(getRouterState, (state): EStorageType => state.storage as EStorageType);
export const getPreviousStorage = createSelector(getRouterState, (state): EStorageType => state.prevStorage as EStorageType);

export const isPublic = createSelector(getCurrentStorage, (state): boolean => state === EStorageType.public);

export const getParams = createSelector(getRouterState, (state) => state.params);

export const isSubscriptionPage = () => window.location?.pathname?.indexOf('/subscriptions') === 0;

export const isLandingPage = () =>
    ['/promocodes', '/discount', '/promo/quota', '/uploader', '/buy', '/promo/quota/ios', '/promo/quota/android'].some((location) =>
        window.location.pathname.startsWith(location)
    );

export const isPageWithoutHeader = () => isLandingPage();

export const selectStatusPage = (state) => getRouterState(state).status;

export const selectHistoryReplace = (state) => getRouterState(state).historyReplace;

export const selectHistoryPath = (state) => getRouterState(state).historyPath;
